import React, {useEffect, useState} from 'react';
import CustomFileUpload from '../FileUpload/CustomFileUpload';
import PickerFilePreview from '../PhotoWebcam/PickerFilePreview';
import WebcamComponent from '../PhotoWebcam/WebcamComponent';
import {FILE_TYPE} from '../../../../Helpers/fileType';

/**
 *
 * @Author: Cecilia López Martínez
 * @JobTitle : Full Stack Developer - IBL
 * @Email : clopez@ibl.mx
 *
 * @param string id: component identifier
 * @param model photoPickerFile: component model
 * @param useState setPhotoPickerFile: state to update the component model
 * @param model accept: file formats and sizes accepted by the component
 * @param boolean showBtnDelete: default value is true, must be set to false if selected files are not required
 * @param boolean required:  default value is false, must be set to true if the field is required
 * @param boolean disabled: for the disabled component
 * @param boolean showBtnCamera: default value is false, must be set to true if the camera option is needed
 * @param boolean validateFace: default value is false, must be set to true if face validation is required
 * @param string titleModalEdit:  required if actionModel === ACTION_MODEL.UPDATE, title for modal
 * @param event handleDelete: required if actionModel === ACTION_MODEL.UPDATE and photo deletion is needed
 * @param string titleInput: title of the dashed-line component (file selection) //
 * @param model typeSuggestions: required if showBtnCamera == true, the model must come from SUGGESTION_MODE_OPTION
 * @param boolean emptyFields: default value is false
 * param boolean inModal: indicates if it's being used inside a modal; this applies to the update action
 * @param state setDisplayModal: State management to ensure only one modal is visible at a time.
 */
const ContentPhotoPicker = (props) => {
    const {
        id,
        accept,
        photoPickerFile,
        setPhotoPickerFile,
        titleInput,
        handleDelete,
        showBtnDelete = true,
        required,
        disabled,
        showBtnCamera,
        validateFace,
        showPreview=true,
        typeSuggestions,
        emptyFields,
        inModal,
        setDisplayModal,
        clear,
        setClear
    } = props;

    const typeImage = accept.name === FILE_TYPE.IMAGE.name;
    const heightInput = !showPreview && typeImage ? 'h-276px' : !showPreview && !typeImage ? '' : '';
    const auxPrev =  showPreview ? showPreview : (photoPickerFile?.fileSelected != null || photoPickerFile?.selfieSrc != null)
    const [startup, setStartup] = useState(false);
    const [selectedCamera, setSelectedCamera] = useState(null);

    useEffect(() => {
        setStartup(false);
    }, []);

    useEffect(() => {
        if(clear){
            handleDeletePicker();
            if(setClear) setClear(false);
        }
    }, [clear]);

    const handleDeletePicker = () => {
        setPhotoPickerFile(prev => ({...prev,
            selfieSrc: null,
            fileSelected: null, // file
            srcSelected: null, // file
        }));
        setStartup(false);
        setSelectedCamera(null);
    }

    return (
        <>
            { auxPrev && (!selectedCamera?.deviceId || photoPickerFile?.selfieSrc ) &&
                <PickerFilePreview
                    typeImage={typeImage}
                    accept={accept}
                    photoPicker={photoPickerFile}
                    handleDelete={()=>{
                        if(typeof handleDelete != 'undefined'){
                            handleDelete();
                        }else{
                            handleDeletePicker();
                        }
                    }}
                    inModal={inModal}
                    showBtnDelete={showBtnDelete && ( photoPickerFile?.fileSelected != null || photoPickerFile?.selfieSrc != null ) }
                />
            }

            { (showBtnCamera && !photoPickerFile?.selfieSrc) &&
                <WebcamComponent
                    photoPicker={photoPickerFile}
                    setPhotoPicker={setPhotoPickerFile}
                    startup={startup}
                    selectedCamera={selectedCamera}
                    setSelectedCamera={setSelectedCamera}
                    setStartup={setStartup}
                    typeSuggestions={typeSuggestions}
                    validateFace={validateFace}
                    setDisplayModal={setDisplayModal}
                />
            }

            { !photoPickerFile?.fileSelected && !selectedCamera?.deviceId && !photoPickerFile?.selfieSrc &&
                <CustomFileUpload
                    id={id}
                    accept={accept}
                    photoPickerFile={photoPickerFile}
                    setPhotoPickerFile={setPhotoPickerFile}
                    titleInput={titleInput}
                    required={required}
                    disabled={disabled}
                    showBtnCamera={showBtnCamera}
                    handleStartupWebcam={()=>{
                        setStartup(true)
                    }}
                    validateFace={validateFace}
                    classHeight={heightInput}
                    emptyFields={emptyFields}
                />
            }
        </>
    )
}

export default ContentPhotoPicker;
